import { render, staticRenderFns } from "./Expired.vue?vue&type=template&id=46972cb4&scoped=true&"
import script from "./Expired.vue?vue&type=script&lang=js&"
export * from "./Expired.vue?vue&type=script&lang=js&"
import style0 from "./Expired.vue?vue&type=style&index=0&id=46972cb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46972cb4",
  null
  
)

component.options.__file = "Expired.vue"
export default component.exports